import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My barcamp Ljubljana report",
  "description": "",
  "published": "2009-01-18T00:00:00.000Z",
  "redirect_from": ["/blog/my-barcamp-ljubljana-report/swizec/16"],
  "categories": "life, review",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.barcamp.si/"
      }}>{`Barcamp Ljubljana`}</a>{` happened yesterday and if you don't know what a barcamp is don't go looking for explanations in this post. I still can't explain what a barcamp is, it's just one of those difficult to epxlain things, like twitter or open source,but I can vouch for them being EXTREMELY fun. No Saturday before had ever flown by so quickly. So yes, I am extremely pleased that I went.`}</p>
    <p>{`We started off in the morning, me wisely coming much earlier than I usually would to something like this (in the words of one Henry Wotton, "I don't have time to be punctual") because I wanted to have a presentation and I've read that the earlier you get there the more slots are left for you to pick from. So I picked a spot at a lovely time in a lovably small classroom ... but they later on moved me into the big lecture hall sine I apparently piqued a lot of people's interests. Err thanks guys, I was totally unprepared, a complete newbie never having given a public presentation before and you go and move me to the big lecture hall. Brilliant.`}</p>
    <p>{`Anyhow, all the talks I was to were quite awesome. Must say I found Andraz Tori's introduction into gaining investments for an idea especially intriguing and I think everyone there really got a lot from the whole thing. The other pearl amongst talks was somebody's talk, sorry I forgot the name of the very cool guy, on data mining. He should work as an actor, it was magnificent to watch.`}</p>
    <p>{`The best thing about barcamps, judging from yesterday's, is that so many great people were there and I don't think I've ever before gotten to know so many new people in a single day. Especially at the party afterwards, wow, hope I didn't make an arse of myself though 'cause the last thing I remember was talking to `}<a parentName="p" {...{
        "href": "http://twitter.com/gandalfar"
      }}>{`@gandalfar`}</a>{` about ... err what were we talking about again ... oh well. I'm sure the important bits will come to me eventually.`}</p>
    <p>{`Can't wait to go to another barcamp.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      